import React from 'react';
import { Button, ButtonGroup, DropdownButton, Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import * as Fi from 'react-icons/fi';

import { User, Table } from 'services/action';
import { FormInput } from '../form/input';

const initialState = {
  showDelete: false,
  isUpdate: false,
};

const Action = ({ data }) => {
  const Dispatch = useDispatch();
  const StateForm = useSelector((state) => state.Form);
  const Session = useSelector((state) => state.Auth?.session);
  const StateTable = useSelector((state) => state?.Table?.data['user']);

  const [{ showDelete, isUpdate }, setState] = React.useState(initialState);

  const $handleClose = () => {
    setState((prevState) => ({
      ...prevState,
      showDelete: false,
      isUpdate: false,
    }));
  };

  const $handleDelete = async () => {
    const del = await Dispatch(User.$delete(data?.id));
    if (del?.message === 'success') {
      $handleClose();
      Dispatch(Table.$reload('user', StateTable));
    }
  };

  if (Session?.user?.id === data?.id) return null;
  return (
    <>
      <DropdownButton
        as={ButtonGroup}
        variant="transparent"
        size="md"
        className="no-carret tbl-action"
        title={<Fi.FiMoreVertical size={13} color="gray" />}
      >
        <button
          className="dropdown-item d-flex align-items-center"
          onClick={() =>
            setState((prevState) => ({ ...prevState, isUpdate: true }))
          }
        >
          <Fi.FiEdit size={15} color="#202020" className="me-2" />
          Perbaharui
        </button>
        <button
          className="dropdown-item d-flex align-items-center"
          onClick={() =>
            setState((prevState) => ({ ...prevState, showDelete: true }))
          }
        >
          <Fi.FiTrash2 size={15} className="me-2" />
          Hapus
        </button>
      </DropdownButton>

      {/* modal delete */}
      <Modal
        show={showDelete}
        onHide={$handleClose}
        backdrop="static"
        centered
        className="text-center"
        size="small"
      >
        <Modal.Body>
          <div className="btn-close" onClick={$handleClose} />
          <div className="modal-status bg-danger" />
          <Fi.FiAlertTriangle className="mb-2 text-danger" size={90} />
          <h3>Anda yakin?</h3>
          <p className="text-danger fw-semibold">
            Data yang sudah dihapus tidak bisa dipulihkan
          </p>

          {/* {isError ? (
            <div className="invalid-feedback" style={{ display: 'block' }}>
              {isError?.id}
            </div>
          ) : null} */}
        </Modal.Body>
        <Modal.Footer>
          <div className="row w-100">
            <div className="col">
              <Button variant="white" className="w-100" onClick={$handleClose}>
                Batal
              </Button>
            </div>
            <div className="col">
              <Button
                variant="danger"
                className={StateForm?.loading ? ' btn-loading w-100' : 'w-100'}
                onClick={$handleDelete}
                disabled={StateForm?.loading}
              >
                Hapus
              </Button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>

      <Modal
        show={isUpdate}
        onHide={$handleClose}
        backdrop="static"
        centered
        size="xl"
        enforceFocus={true}
      >
        <Modal.Header closeButton>
          <Modal.Title>Perbaharui User</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <FormInput onClose={$handleClose} data={data} />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Action;
